module.exports = __webpack_public_path__ + "static/media/plaque_6h22.54d8a46b.png";